import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useAuditLog(matterId?: string) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['audit_log', user?.id, matterId],
    enabled: !!user,
    queryFn: async () => {
      let query = supabase.from('audit_log').select('*').order('created_at', { ascending: false });
      if (matterId) query = query.eq('matter_id', matterId);
      const { data, error } = await query;
      if (error) throw error;
      return data;
    },
  });
}
